import React from 'react';

interface LoadingSpinnerProps {
    size?: 'sm' | 'md' | 'lg'; // Size options for the spinner
    color?: 'blue' | 'green' | 'gray' | 'white'; // Color options for the spinner
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
    size = 'md',
    color = 'blue'
}) => {
    const sizeClasses = {
        sm: 'w-4 h-4',
        md: 'w-5 h-5',
        lg: 'w-6 h-6'
    };

    const colorClasses = {
        blue: 'border-blue-600',
        green: 'border-green-600',
        gray: 'border-gray-600',
        white: 'border-white'
    };

    return (
        <div
            className={`animate-spin rounded-full border-2 border-t-transparent ${sizeClasses[size]} ${colorClasses[color]}`}
        />
    );
};

export default LoadingSpinner;
